<template>
  <div>
    <div class="count_center">
      <el-alert
        title="暂未开放此业务"
        type="warning"
        description="请联系管理员"
        show-icon
        :closable="false"
      >
      </el-alert>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
h1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding: 54px;
  box-sizing: border-box;
}
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/buikAllbox/buikAllbox.vue